<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main max-w max-gl" id="page-content-main">
    <epay-lib-common-forgotpassword [baseurl]="baseurl">
    </epay-lib-common-forgotpassword>
  </div>
</epay-page-content>
